// extracted by mini-css-extract-plugin
module.exports = {"cultivo-tr":"cards_cultivo-tr__3nGZy","trabajador-actividad-list":"cards_trabajador-actividad-list__1s3o3"};